// TODO: type this — Vuex module context
/* eslint-disable @typescript-eslint/no-explicit-any */
type Ctx = any;
/* eslint-enable @typescript-eslint/no-explicit-any */

interface AssetState {
    assets: Record<string, HTMLImageElement>;
}

const AssetStore = {
    namespaced: true,
    state: {
        assets: {} as Record<string, HTMLImageElement>,
    },
    mutations: {
        add(state: AssetState, { url, image }: { url: string; image: HTMLImageElement }): void {
            state.assets[url] = image;
        },
    },
    actions: {
        async load({ state, commit }: Ctx, url: string): Promise<HTMLImageElement> {
            if (Object.prototype.hasOwnProperty.call(state.assets, url)) {
                return state.assets[url];
            }
            const image = await loadImage(url);
            commit('add', { url, image });
            return image;
        },
    },
};

function loadImage(url: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = url;
    });
}

export default AssetStore;
